import { Text, View } from '@react-pdf/renderer';

// Utils
import { htmlToSpacedPlainText } from '@/utils/htmlSerializer';

// Tokens
import theme, { SECTION_TITLES } from '@/components/template/resume/AgilityIO/tokens';

// Styles
import styles from '../style';
interface PersonalInfoSectionProps {
  name: string;
  title: string;
  address: string;
  bio: string;
}
const PersonalInfoSection = ({
  name,
  title,
  address,
  bio
}: PersonalInfoSectionProps) => {
  const plainBio = htmlToSpacedPlainText(bio);
  return <View data-sentry-element="View" data-sentry-component="PersonalInfoSection" data-sentry-source-file="PersonalInfo.tsx">
      {/* Hero */}
      <View style={styles.section} data-sentry-element="View" data-sentry-source-file="PersonalInfo.tsx">
        {name && <Text style={styles.heroName}>{name}</Text>}
        {title && <Text style={styles.heroJobTitle}>{title}</Text>}

        {address && <Text style={styles.heroLocation}>
            {address}
            {/* TODO: Support later - append timezone: [address, timezone].filter(Boolean).join(' | ') */}
          </Text>}
      </View>

      {/* Professional Profile */}
      {plainBio && <View style={styles.section}>
          <Text style={[styles.sectionHeading, {
        marginBottom: theme.spacing.sectionHeadingGap
      }]}>
            {SECTION_TITLES.professionalProfile}
          </Text>
          <Text style={styles.entryMeta}>{plainBio}</Text>
        </View>}
    </View>;
};
export default PersonalInfoSection;